// REDUCERS DE EJEMPLO INCLUIDOS EN EL TEMPLATE (QUITAR DESPUES)
import { combineReducers } from 'redux';
import themeUsersReducer from './themeUsers/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { teamReducer } from './team/reducers';
import { sellersReducer } from './sellers/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import orderReducer from './orders/reducers';
import galleryReducer from './gallary/reducers';
import chartContentReducer from './chartContent/reducers';
import { emailReducer, SingleEmailReducer } from './email/reducers';
import { productReducer, SingleProductReducer } from './product/reducers';
import cartData from './cart/reducers';
import Note from './note/reducers';
import Profile from './profile/reducers';
import Calender from './calendar/reducers';


// REDUCERS DEL PROYECTO
import sucursalCrudReducer from './administracion/sucursales/reducers';
import empleadoCrudReducer from './administracion/empleados/reducers';
import responseReducer from './responseAction/reducers';
import catalogosReducer from './catalogos/reducers';
import pacienteCrudReducer from './clinica/pacientes/reducers';
import gastosCrudReducer from './clinica/gastos/reducers';
import servicioCrudReducer from './administracion/servicios/reducers';
import productoCrudReducer from './administracion/productos/reducers';
import categoriaServiciosCrudReducer from './configuracion/categoriaServicios/reducers';
import corteCajaReducer from './clinica/corte/reducers';
import tipoOrigenPacienteCrudReducer from './configuracion/tipoOrigenPaciente/reducers';
import claveDescuentoCrudReducer from './configuracion/claveDescuento/reducers';
import esquemasContractualesCrudReducer from './configuracion/esquemasContractuales/reducers';
import empresasCrudReducer from './ventas/empresas/reducers';
import pagosRegistradosCrudReducer from './finanzas/pagosRegistrados/reducers';
import membresiaCrudReducer from './membresia/reducers';

const rootReducers = combineReducers({
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,
  notification: readNotificationReducer,
  orders: orderReducer,
  sellers: sellersReducer,
  team: teamReducer,
  auth: authReducer,
  gallery: galleryReducer,
  email: emailReducer,
  emailSingle: SingleEmailReducer,
  products: productReducer,
  product: SingleProductReducer,
  ChangeLayoutMode,
  chartContent: chartContentReducer,
  cart: cartData,
  Note,
  Profile,
  Calender,
  responseReducer: responseReducer,
  EmpleadoReducer: empleadoCrudReducer,
  SucursalReducer: sucursalCrudReducer,
  CatalogosReducer: catalogosReducer,
  PacienteReducer: pacienteCrudReducer,
  GastosCrudReducer: gastosCrudReducer,
  ServicioReducer: servicioCrudReducer,
  ProductoReducer: productoCrudReducer,
  CategoriaServicioReducer: categoriaServiciosCrudReducer,
  CorteCajaReducer: corteCajaReducer,
  TipoOrigenPacienteCrudReducer: tipoOrigenPacienteCrudReducer,
  ClaveDescuentoCrudReducer: claveDescuentoCrudReducer,
  EsquemasContractualesCrudReducer: esquemasContractualesCrudReducer,
  EmpresasCrudReducer: empresasCrudReducer,
  PagosRegistradosCrudReducer: pagosRegistradosCrudReducer,
  MembresiaCrudReducer: membresiaCrudReducer
 
});

export default rootReducers;
